export const SET_DEV_TOOLS_STATUS = 'SET_DEV_TOOLS_STATUS';

export const setDevToolsStatus = status => ({
  type: SET_DEV_TOOLS_STATUS,
  status
});
